import { defineType } from "sanity";

export default defineType({
  name: "keyFeatures",
  title: "Key Features",
  type: "object",
  fields: [
    {
      name: "veranda",
      title: "Veranda",
      type: "boolean"
    },
    {
      name: "livingRoom",
      title: "Living Room",
      type: "boolean"
    },
    {
      name: "location",
      title: "Location",
      type: "boolean"
    },
    {
      name: "suiteHighlight",
      title: "Suite Highlight",
      type: "boolean"
    },
    {
      name: "extraFeatures",
      title: "Extra Features",
      type: "boolean"
    }
  ]
});
